export default __webpack_public_path__ + "static/media/ariin.e809d997.png";